import React, { useState, useEffect } from 'react';
import { tanks as initialTanks } from '../../data/appData';
import { fetchTanks, fetchProducts, api, deleteTank, BASE_URL } from '../../services/api';

const emptyForm = {
  tankNo: '',
  name: '',
  product: '',
  capacity: '',
  minLevel: '',
  status: 'Active'
};

export default function Tank({ user }) {
  const companyId = user?.Companyid || user?.company_id || "1";

  const [tanks, setTanks] = useState(initialTanks);
  const [products, setProducts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState(emptyForm);

  /* ================= VALIDATION ================= */

  const validateForm = () => {

    // if (!editId && !form.tankNo.trim()) {
    //   alert("Tank No is required");
    //   return false;
    // }

    if (!form.name.trim()) {
      alert("Tank Name is required");
      return false;
    }

    if (!form.product || form.product.trim() === "") {
      alert("Product is required");
      return false;
    }

    if (!form.capacity || Number(form.capacity) <= 0) {
      alert("Capacity must be greater than 0");
      return false;
    }

    if (!form.minLevel || Number(form.minLevel) <= 0) {
      alert("Minimum level is required");
      return false;
    }

    return true;
  };

  /* ================= LOAD TANK LIST ================= */

  const loadTanks = async () => {

    try {
      const res = await fetch(`${BASE_URL}Pages/TankView.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Companyid: companyId })
        }
      );

      const data = await res.json();

      if (data.success && data.Response) {

        const tankList = Array.isArray(data.Response)
          ? data.Response
          : [data.Response];

        const formatted = tankList.map(tank => {
          const rawName = tank.TankName || '';
          // Extract tank number from start of string (e.g. "1: HSD" -> "1")
          const noMatch = rawName.match(/^Tank\s*(\d+)/i) || rawName.match(/^(\d+)/);
          const tNo = noMatch ? noMatch[1] : '';
          // Clean name for display (remove the "Tank 1: " prefix if present)
          const cleanName = rawName.replace(/^Tank\s*\d+[:\s-]*/i, '').replace(/^\d+[:\s-]*/, '');
          
          return {
            id: tank.Tankid,
            tankNo: tNo,
            name: cleanName || rawName,
            product: tank.ProductName,
            capacity: Number(tank.Capacity),
            minLevel: Number(tank.MinLevel),
            status: tank.Status
          };
        });

        setTanks(formatted);

      }

    } catch (err) {

      console.error("TankView API error:", err);

    }

  };

  /* ================= LOAD PRODUCTS ================= */

  const loadProducts = async () => {

    try {
      const res = await fetch(`${BASE_URL}Pages/ProductView.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Companyid: companyId })
        }
      );

      const data = await res.json();

      if (data.success && data.Response) {

        const list = Array.isArray(data.Response)
          ? data.Response
          : [data.Response];

        setProducts(list);

        if (list.length > 0) {
          setForm(prev => ({
            ...prev,
            product: list[0].Name
          }));
        }

      }

    } catch (err) {

      console.error("ProductView API error:", err);

    }

  };

  useEffect(() => {

    loadTanks();
    loadProducts();

  }, [companyId]);

  /* ================= ADD ================= */

  const openAdd = () => {
  setEditId(null);

    setForm({
      ...emptyForm,
      product: products.length > 0 ? products[0].Name : ''
    });

    setShowForm(true);
  };

  /* ================= EDIT ================= */

  const openEdit = (t) => {

    setEditId(t.id);

    setForm({
      tankNo: (t.tankNo || '').toString(),
      name: t.name,
      product: t.product,
      capacity: t.capacity,
      minLevel: t.minLevel,
      status: t.status || 'Active'
    });

    setShowForm(true);
  };

  /* ================= SAVE ================= */

  const handleSave = async () => {

  if (!validateForm()) return;

  try {
    const res = await fetch(`${BASE_URL}Pages/TankReg.php`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Companyid: companyId,
          Name: form.name,
          Product: form.product,
          Capacity: String(form.capacity),
          MinLevel: String(form.minLevel),
          Status: form.status,
          IDS: editId ? String(editId) : "0"
        })
      }
    );

    const data = await res.json();

    if (data.success || data.Response === "UPDATED" || data.Response === "INSERTED") {
      setShowForm(false);
      await loadTanks();
    }

  } catch (err) {
    console.error("Tank API error:", err);
  }
};

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this tank?')) return;
    
    try {
      const result = await deleteTank(id);
      if (result.success || result.Response === "DELETED" || result.status === "Success") {
        await loadTanks();
      } else {
        alert(result.message || "Failed to delete tank");
      }
    } catch (err) {
      console.error("Tank Delete error:", err);
      alert("Something went wrong while deleting");
    }
  };

  return (
    <div className="pump-page">

      <div className="page-header">
        <h2 className="page-title">Master/Tank Management</h2>
        <button className="btn btn-primary btn-sm" onClick={openAdd}>
          ＋ Add Tank
        </button>
      </div>

      {showForm && (

        <div className="section-card">

          <div className="section-header">
            {editId ? 'Edit Tank' : 'Add Tank'}
          </div>

          <div className="form-row">

            {/* <div className="form-group">
              <label>Tank No. <span className="required">*</span></label>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder='Tank No'
                className="form-control"
                value={form.tankNo}
                disabled={!!editId}
                onChange={e => setForm({ ...form, tankNo: e.target.value.replace(/\D/g, '') })}
              />
            </div> */}

            <div className="form-group">
              <label>Name <span className="required">*</span></label>
              <input
                className="form-control"
                value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Product <span className="required">*</span></label>
              <select
                className="form-control"
                value={form.product}
                onChange={e => setForm({ ...form, product: e.target.value })}
              >
                <option value="">Select Product</option> {/* ✅ ADD THIS LINE */}

                {products.map(p => (
                  <option key={p.Productid} value={p.Name}>
                    {p.Name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Capacity (L) <span className="required">*</span></label>
              <input
                type="number"
                className="form-control"
                value={form.capacity}
                onChange={e => setForm({ ...form, capacity: e.target.value })}
              />
            </div>



            <div className="form-group">
              <label>Min Level (L) <span className="required">*</span></label>
              <input
                type="number"
                className="form-control"
                value={form.minLevel}
                onChange={e => setForm({ ...form, minLevel: e.target.value })}
              />
            </div>



            <div className="form-group">
              <label>Status*</label>
              <select
                className="form-control"
                value={form.status}
                onChange={e => setForm({ ...form, status: e.target.value })}
              >
                <option>Active</option>
                <option>Inactive</option>
               

              </select>
            </div>

          </div>

          <div className="action-bar" style={{ padding: '0 16px 14px' }}>

            <button className="btn btn-primary" onClick={handleSave}>
              💾 {editId ? "Update Tank" : "Save Tank"}
            </button>

            <button
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              ✕ Cancel
            </button>

          </div>

        </div>

      )}

      {/* TABLE REMAINS SAME */}

      <div className="section-card">

        <div className="section-header">
          Tank List — {tanks.length} records
        </div>

        <div className="table-wrapper">

          <table className="data-table">

            <thead>
              <tr>
                <th className="text-center">Tank No.</th>
                <th className="text-left">Tank Name</th>
                <th className="text-left">Product</th>
                <th className="text-right">Capacity (L)</th>
                <th className="text-right">Min Level (L)</th>
                <th className="text-center">Status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {tanks.map((t) => (
                <tr key={t.id}>
                  <td className="text-center" style={{ fontFamily: 'monospace', fontWeight: 700, color: 'var(--primary)' }}>{t.tankNo}</td>
                  <td className="text-left" style={{ fontWeight: 600 }}>{t.name}</td>
                  <td className="text-left">{t.product}</td>
                  <td className="text-right">{parseFloat(t.capacity || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                  <td className="text-right">{parseFloat(t.minLevel || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                  <td className="text-center">
                    <span className={`badge ${t.status === 'Active' ? 'badge-success' : 'badge-warning'}`}>
                      {t.status}
                    </span>
                  </td>
                  <td className="text-center">
                    <button className="icon-btn" onClick={() => openEdit(t)} title="Edit">
                      <i className="bi bi-pencil-square"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}